module.exports = __webpack_public_path__ + "assets/c4a2b870062c2bb98c500bc1526c0498.png";